import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  barChartContainer: {
    flex: 0.7,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    justifyContent: 'flex-start',
    '@media (min-width: 640px)': { minWidth: '640px' },
  },
  barChartDiv: {
    flex: 1,
    minHeight: '360px',
  },
  legend: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '@media (min-width: 640px)': { padding: '0 50px' },
  },
  pieChartsContainer: {
    minWidth: 'fit-content',
    flex: 0.3,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    '@media (min-width: 640px)': {
      gap: '24px',
    },
  },
  pieChartContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '@media (min-width: 640px)': {
      gap: '16px',
    },
  },
  pieChartDiv: {
    display: 'flex',
    columnGap: '26px',
    alignItems: 'center',
  },
}));
